export const LOCATIONS_TREE_ROOT_NODE_ID = 'root'
export const NEW_LOCATION_ID = 'new';

export const LOCATION_TABS = {
    all: "all",
    my: "my"
}